import React, { useEffect, useState } from "react";
import {
  Typography,
  Form,
  Input,
  Option,
  Switch,
  Button,
  Spin,
  message,
} from "antd";
import { apiRoutes } from "../../auth/apiRoute";
import axios from "axios";
export default function Settings() {
  const { Title, Paragraph } = Typography;
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [form] = Form.useForm();
  useEffect(() => {
    getSettings();
  }, []);
  useEffect(() => {
    form.setFieldsValue(settings);
  }, [loading]);
  const getSettings = async () => {
    setLoading(true);
    try {
      const res = await axios.get(apiRoutes["admin/settings"]);
      console.log(res.data);
      for (const setting of res.data) {
        settings[setting.name] = setting.value;
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const syncHotels = async () => {
    setSyncing(true);
    try {
      const res = await axios.post(apiRoutes["admin/syncHotels"]);
      message.success(res.data);
    } catch (error) {
      message.error(error.response?.data || "Failed to sync hotels");
    }
    setSyncing(false);
  };

  const saveSettings = async (data) => {
    try {
      const res = await axios.post(apiRoutes["admin/settings"], data);
      console.log(res.data);
      message.success(res.data);
    } catch (error) {
      console.log(error);
      message.error(error.response.data);
    }
  };

  return (
    <div style={{ background: "white", padding: "2rem" }}>
      <Title level={1}>Settings</Title>
      <Spin spinning={loading}>
        <Form
          form={form}
          onFinish={(data) => {
            console.log(data);
            saveSettings(data);
          }}
        >
          <Form.Item
            label="Allow Nomination"
            name="isAcceptingNomination"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label="Allow First Round Judging"
            name="isJudgingNomination"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item
            label="Allow Final Round "
            name="isFinalJudgingNomination"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <Form.Item>
            <Button htmlType="submit" type="primary">
              Save
            </Button>
          </Form.Item>
        </Form>
        <div style={{ marginTop: "2rem" }}>
          <Title level={3}>Hotel Management</Title>
          <Button
            type="default"
            loading={syncing}
            onClick={syncHotels}
          >
            Sync Hotels
          </Button>
        </div>
      </Spin>
    </div>
  );
}
